/**************************************************
 * Nombre:       Formulario_Pedido_Datos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import {
    AccountBalance,
    AccountCircle,
    AccountCircleOutlined,
    BadgeOutlined,
    Flag,
    PictureAsPdf,
    SmartphoneOutlined,
    WhatsApp
} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {useEffect, useState} from "react";
import {iniciarCharWass} from "../../Utilidades/iniciarCharWass";
import Tarjeta_Producto from "../../Modulo_Wompi/Tarjetas/Tarjetas_Producto";
import {PDFDownloadLink} from "@react-pdf/renderer";
import Pdf_Recibo from "../../Modulo_Wompi/Pdfs/Pdf_Recibo";
import logo from '../../Recursos/logo_color.png'
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOPEDIDO} from "../../Constantes";


const Formulario_Pedido_Datos = ({...props}) => {
    const [numero, setNumero] = useState('')
    const [articulos, setArticulos] = useState([])
    const [datos, setDatos] = useState()


    useEffect(() => {

        let num = props.props.getValues('celular')
        let prods = props.props.getValues('productos')
        let ped = props.props.getValues()
        setNumero(num)
        if (prods) setArticulos(prods)
        if (ped) setDatos(ped)


    }, [props.props.watch('celular')]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6}>
                    <IngresoSelect Icono={Flag} nombre={'Estado del Pedido'} editable={datos && !datos.descargado}
                                   dato={'estado'} {...props} opciones={ESTADOPEDIDO.map((it) => it.nombre)}/>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={AccountBalance} nombre={'Estado Pago'} dato={'estadoPago'} {...props} editable={false} />
                </Grid>

                <Grid container size={6}>
                    {datos && datos.descargado &&
                        <Typography sx={{fontSize: 14, lineHeight: 1.1}}>
                            {'Articulos ya descargados'}
                        </Typography>
                    }
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Datos de personales</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircle} nombre={'Nombres'} dato={'nombres'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Apellidos'} dato={'apellidos'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={BadgeOutlined} nombre={'Num Identificacion'} dato={'cc'} {...props} />
                </Grid>

                <Grid container size={6}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Celular'} dato={'celular'} {...props} />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={SmartphoneOutlined} nombre={'Correo'} dato={'correo'} {...props} />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                    <Button
                        onClick={() => iniciarCharWass(numero)}
                        variant={'outlined'} startIcon={<WhatsApp/>}>ir WhatsApp</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography>Articulos pedidos</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        {articulos.map((it) => {
                            return (
                                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                                    <Tarjeta_Producto item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'flex-end'}>
                    {datos && datos.id &&
                        <PDFDownloadLink document={<Pdf_Recibo logo={logo} datos={datos}/>}
                                         fileName={"Recibo de compra " + datos.consecutivo}
                                         style={{textDecoration: "none"}}>
                            <Button
                                variant={'outlined'}
                                startIcon={<PictureAsPdf/>}
                            >Descargar Recibo</Button>
                        </PDFDownloadLink>
                    }
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Notas Internas'} dato={'notas'} {...props} />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Pedido_Datos